import { Box } from '@mui/material'
import ReactPanZoom from 'react-image-pan-zoom-rotate'

type ImageViewerProps = {
  src: string
  alt: string
  // コントロールボタンの上端位置（デフォルト: 10px）
  controlsTop?: number
}

export default function ImageViewer({ src, alt, controlsTop }: ImageViewerProps) {
  // コントロールボタンの位置を調整する場合のみラッパーを使用
  if (controlsTop !== undefined) {
    return (
      <Box
        sx={{
          position: 'relative',
          // ライブラリ内部のコントロールパネルの位置をオーバーライド
          '& > div > div:first-of-type': {
            top: `${controlsTop}px !important`,
          },
        }}
      >
        <ReactPanZoom image={src} alt={alt} />
      </Box>
    )
  }

  return <ReactPanZoom image={src} alt={alt} />
}
